/**
 * Csv Schema of ResponseRobo
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {ResponseRobo} from '@/model/resource/ResponseRobo'

/* TODO: review generated schema */
export class CsvResponseRoboSchema extends Schema {
  readonly name = 'CsvResponseRobo'

  readonly fieldSet: FieldSet<ResponseRobo> = {
    idResponsePk: schema => schema.model.idResponsePk,
    danfe: schema => schema.model.danfe,
    response: schema => schema.model.response,
    ehCte: schema => Helper.bool(schema.model.ehCte),
  }
}
